import "../styles/blocks/privacy-policy/privacy-policy.scss";

import React, { useEffect } from "react";

import DefaultLayout from "../layouts/DefaultLayout";
import DefaultHelmet from "../seo/DefaultHelmet";
import beaconWidgetIds from "../settings/beacon-widget-ids";
import useBeaconWidget from "../hooks/useBeaconWidget";
import PageHeader from "../components/PageHeader";

const Project = ({ pageContext }) => {
  const {
    page_header: pageHeader,
    title,
    acfPrivacyPolicy,
  } = pageContext;

  const pageTitle = title || "Privacy Policy";
  const pageDescription = "Privacy Policy Page";
  const pageContent = acfPrivacyPolicy?.content;

  useBeaconWidget(beaconWidgetIds.GENERAL);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const scrollToHashTarget = () => {
      const hash = window.location.hash;
      if (!hash) return;

      let targetId = hash.slice(1);

      try {
        targetId = decodeURIComponent(targetId);
      } catch (error) {
        return;
      }

      const target = document.getElementById(targetId);
      if (!target) return;

      target.scrollIntoView({ block: "start" });
    };

    const handleHashChange = () => {
      window.requestAnimationFrame(scrollToHashTarget);
    };

    const appendPageContent = () => {
      const target = document.querySelector("#iubenda_policy .iub_content.legal_pp");
      if (!target || !pageContent || target.querySelector(".privacy-policy__content")) {
        return false;
      }

      const wrapper = document.createElement("div");
      wrapper.innerHTML = pageContent;
      wrapper.classList.add("rte", "privacy-policy__content");
      target.appendChild(wrapper);

      window.requestAnimationFrame(scrollToHashTarget);

      return true;
    };

    let observer = null;

    const script = document.createElement("script");
    script.src = "https://cdn.iubenda.com/iubenda.js";
    script.async = true;

    script.onload = () => {
      observer = new MutationObserver(() => {
        if (appendPageContent()) {
          observer.disconnect();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      appendPageContent();
    };

    window.addEventListener("hashchange", handleHashChange);
    document.body.appendChild(script);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
      observer?.disconnect();
      document.body.removeChild(script);
    };
  }, [pageContent]);

  return (
    <DefaultLayout isHeaderWithBlackText={true}>
      <DefaultHelmet title={pageTitle} description={pageDescription} />

      <PageHeader {...pageHeader} isGeneral={true} />

      <div className="container privacy-policy">
        <a
          href="https://www.iubenda.com/privacy-policy/40829989"
          className="iubenda-nostyle iubenda-noiframe iubenda-embed iub-legal-only iubenda-noiframe iub-body-embed"
          title="Privacy Policy"
        >
          Privacy Policy
        </a>
      </div>
    </DefaultLayout>
  )
};

export default Project;
